import { render, staticRenderFns } from "./GameColorTabs.vue?vue&type=template&id=727ff50e&scoped=true&"
import script from "./GameColorTabs.vue?vue&type=script&lang=js&"
export * from "./GameColorTabs.vue?vue&type=script&lang=js&"
import style0 from "./GameColorTabs.vue?vue&type=style&index=0&id=727ff50e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ff50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('727ff50e')) {
      api.createRecord('727ff50e', component.options)
    } else {
      api.reload('727ff50e', component.options)
    }
    module.hot.accept("./GameColorTabs.vue?vue&type=template&id=727ff50e&scoped=true&", function () {
      api.rerender('727ff50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/GameColorTabs.vue"
export default component.exports